<template>
  <e-button
    :class="b('', { variant })"
    :aria-label="label"
    @click.stop.prevent="toggleFavorit(product)"
  >
    <e-icon
      :class="b('icon', { isActive })"
      :icon="isActive ? 'i-heart--full' : 'i-heart--empty'"
      size="24"
    />
    <span>
      {{ label }}
    </span>
  </e-button>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import useFavoritesStore from '@/stores/favorites';
  import eButton from '@/elements/e-button.vue';
  import eIcon from '@/elements/e-icon.vue';
  import { FavoritesProduct } from '@/types/product';

  type Setup = {
    favoritesStore: ReturnType<typeof useFavoritesStore>;
  };
  // type Data = {};

  /**
   * Renders a button to add and remove a product to and from the favorites store.
   */
  export default defineComponent({
    name: 'c-favorite-product-toggle',
    components: {
      eButton,
      eIcon,
    },

    // components: {},

    props: {
      /**
       * Define the variant of the button
       */
      variant: {
        type: String,
        default: 'regular',
        validator: (value: string) => ['regular', 'small'].includes(value),
      },

      /**
       * The product to add to the favorites store
       */
      product: {
        type: Object as PropType<FavoritesProduct>,
        required: true,
      },
    },
    // emits: {},

    setup(): Setup {
      return {
        favoritesStore: useFavoritesStore(),
      };
    },
    // data(): Data {
    //   return {};
    // },

    computed: {
      isActive(): boolean {
        return !!this.favoritesStore.favorites?.some((favorite) => favorite.id === this.product.id);
      },

      label(): string {
        return this.isActive ? this.$t('c-add-to-favorites.remove') : this.$t('c-add-to-favorites.add');
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      if (!this.favoritesStore.favorites) {
        this.favoritesStore.apiFetchFavorites();
      }
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      toggleFavorit(product: FavoritesProduct): void {
        if (this.isActive) {
          this.favoritesStore.removeFavorite(this.product);

          return;
        }

        this.favoritesStore.addFavorite(product, this.$t('c-add-to-favorites.limit-reached'));
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  @use 'sass:map';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';

  .c-favorite-product-toggle {
    &--variant-small {
      font-size: 0.75rem;

      svg {
        width: 1.25rem;
      }
    }

    .e-button__inner {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.25rem;
    }

    &__icon {
      width: 1.5rem;
    }
  }
</style>
